export default class SubscriptionInput {
	constructor(
        public SubscriberUri: string,
        public BundleId: string
    ) { }
}